import { render, staticRenderFns } from "./prevBuild.vue?vue&type=template&id=0f42a566&"
import script from "./prevBuild.vue?vue&type=script&lang=js&"
export * from "./prevBuild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports